// components/UserStoriesSection/UserStoriesSection.js
import React from "react";
import { motion } from "framer-motion";
import { Box, Typography, Container, Grid } from "@mui/material";
import UserStoryCard from "./UserStoryCard";
import cleanFreekAnime from "../../assets/lottie/CleanFreekAnime.json";
import gammerAnime from "../../assets/lottie/gammerAnime.json";
import nightOwlAnime2 from "../../assets/lottie/nightOwlAnime2.json";

const UserStoriesSection = ({ isMobile }) => {
  const userStories = [
    {
      animationData: cleanFreekAnime,
      title: "The Clean Freak",
      description: "Loves everything to be spotless! Perfect match for someone who can handle cleanliness at its best.",
      emoji: "🧹",
      color: "#00ff88",
    },
    {
      animationData: nightOwlAnime2,
      title: "The Night Owl",
      description: "Needs a midnight snack and prefers to work at night. Perfect match with someone who loves the quiet after-hours!",
      emoji: "🌙",
      color: "#0099ff",
    },
    {
      animationData: gammerAnime,
      title: "The Gamer",
      description: "Spends hours on the console and is highly focused. Find a roommate who can vibe with gaming sessions!",
      emoji: "🎮",
      color: "#ff3366",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  return (
    <Box
      sx={{
        py: 10,
        background: "linear-gradient(180deg, rgba(0, 53, 102, 0.8) 0%, rgba(0, 29, 61, 0.9) 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Typography
            variant={isMobile ? "h3" : "h2"}
            align="center"
            sx={{
              fontWeight: 800,
              mb: 2,
              background: "linear-gradient(45deg, #00ff88, #0099ff)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
            }}
          >
            Real Roommate Vibes
          </Typography>
          
          <Typography
            variant="h6"
            align="center"
            sx={{
              color: "rgba(255,255,255,0.8)",
              mb: 6,
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            Discover personalities that match your lifestyle
          </Typography>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <Grid container spacing={4} justifyContent="center">
            {userStories.map((story, index) => (
              <Grid item xs={12} md={4} key={index}>
                <UserStoryCard {...story} index={index} isMobile={isMobile} />
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default UserStoriesSection;